import { render } from "./LanguageSelector.vue?vue&type=template&id=20876286"
import script from "./LanguageSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/exhishare/LanguageSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20876286"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20876286', __exports__)) {
    api.reload('20876286', __exports__)
  }
  
  module.hot.accept("./LanguageSelector.vue?vue&type=template&id=20876286", () => {
    api.rerender('20876286', render)
  })

}


export default __exports__